var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostaidev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.505,
    height: 65.643,
    viewBox: "0 0 66.505 65.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.134 32.271)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.563,33.371H11.808A2.811,2.811,0,0,1,9,30.563V11.808A2.811,2.811,0,0,1,11.808,9H30.563a2.811,2.811,0,0,1,2.808,2.808V30.563A2.811,2.811,0,0,1,30.563,33.371ZM11.808,10A1.81,1.81,0,0,0,10,11.808V30.563a1.81,1.81,0,0,0,1.808,1.808H30.563a1.81,1.81,0,0,0,1.808-1.808V11.808A1.81,1.81,0,0,0,30.563,10Z",
    transform: "translate(-9.5 -9.5)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.794.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H22.794a.5.5,0,0,1,.5.5A.5.5,0,0,1,22.794.5Z",
    transform: "translate(0.433 4.617)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.462.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H3.462a.5.5,0,0,1,.5.5A.5.5,0,0,1,3.462.5Z",
    transform: "translate(2.741 2.308)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.703,
    cy: 0.703,
    r: 0.703,
    transform: "translate(14.229 1.605)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.703,
    cy: 0.703,
    r: 0.703,
    transform: "translate(17.114 1.605)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.703,
    cy: 0.703,
    r: 0.703,
    transform: "translate(19.999 1.605)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.541 19.811)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.749,51.289a.5.5,0,0,1-.354-.146l-2.777-2.777a.5.5,0,0,1,0-.707L29.4,44.881a.5.5,0,0,1,.707.707l-2.423,2.423L30.1,50.435a.5.5,0,0,1-.354.854Z",
    transform: "translate(-26.972 -45.235)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4,51.289a.5.5,0,0,1-.354-.854l2.423-2.423L63.05,45.589a.5.5,0,0,1,.707-.707l2.777,2.777a.5.5,0,0,1,0,.707l-2.777,2.777A.5.5,0,0,1,63.4,51.289Z",
    transform: "translate(-52.892 -45.235)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-47.676 -52.082)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6a.5.5,0,0,1-.166-.028.5.5,0,0,1-.306-.637l1.934-5.5A.5.5,0,0,1,2.1-.472a.5.5,0,0,1,.306.637L.472,5.669A.5.5,0,0,1,0,6Z",
    transform: "translate(5.462 0.025)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostaidev);
export default __webpack_public_path__ + "static/media/hostaidev.3cacd93b.svg";
export { ForwardRef as ReactComponent };